document.addEventListener('DOMContentLoaded', () => {

    const $ = document.querySelector.bind(document)
 let viewers = 174;
  let buyers = 2643;  
  
  setInterval(() => {

    const viewersElement = $('#viewers');
    const buyersElement = $('#buyers');
    
    viewers = Math.floor(Math.random() * 101) + 100;
    buyers += Math.floor(Math.random() * 100) + 10;
    
    viewersElement.innerText = viewers;
    buyersElement.innerText = buyers;
  }, 5000);
const countdownMinutes = 13;
let countdownTime = countdownMinutes * 60 * 1000; 
let endTime = new Date().getTime() + countdownTime; 
let pausedTime = 0; 
let timerInterval;
let popupShown = false;
function updateCountdown() {
  const now = new Date().getTime();
  const remainingTime = endTime - now;
  const countdownElement = document.getElementById('countdown');
  if (!countdownElement) {
    console.error("Không tìm thấy phần tử có ID 'countdown'.");
    return;
  }
  if (remainingTime <= 0) {
    if (!popupShown) {
      countdownElement.innerHTML = `
      <span class="countdown-ended">You've got the best clearance deal!</span>`
      clearInterval(timerInterval);
      showPopup();
      popupShown = true;
    }
    return;
  }

  const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

  
  
  countdownElement.innerHTML = `
    <span class="countdown-clearance">Clearance</span>
    <span class="countdown-sale"> - Sale ends in </span>
    <span class="countdown-time">
      ${hours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s
    </span>
  `;
}
  function showPopup() {
    document.body.style.overflow = 'hidden';
    const popup = document.createElement('div');
    popup.id = 'popup';
    popup.style.position = 'fixed';
    popup.style.top = '0';
    popup.style.left = '0';
    popup.style.width = '100%';
    popup.style.height = '100%';
    popup.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    popup.style.display = 'flex';
    popup.style.justifyContent = 'center';
    popup.style.alignItems = 'center';
    popup.style.zIndex = '9999';
    popup.style.overflow = 'hidden'; 

    const popupContent = document.createElement('div');
    popupContent.style.backgroundColor = 'white';
    popupContent.style.padding = '30px';
    popupContent.style.textAlign = 'center';
    popupContent.style.borderRadius = '8px';
    popupContent.style.width = '80%';
    popupContent.style.maxWidth = '500px';

    const text1 = document.createElement('p');
    text1.textContent = 'CLEARANCE SALE 81% OFF!';
    text1.style.fontSize = '40px';
    text1.style.fontWeight = 'bold';
    text1.style.color = '#cd2c31'; 
    text1.style.lineHeight = "40px"

    const text2 = document.createElement('p');
    text2.textContent = 'Discounts starting from 81% have already been applied to this product';
    text2.style.fontSize = '18px';
    text2.style.fontWeight = 'normal';
    text2.style.color = 'black'; 

    const button = document.createElement('button');
    button.textContent = "Don't wait, Shop Now!";
    button.style.backgroundColor = '#282828';
    button.style.color = 'white';
    button.style.fontSize = '16px';
    button.style.fontWeight = 'bold';
    button.style.padding = '20px 30px';
    button.style.border = 'none';
    button.style.borderRadius = '5px';
    button.style.marginTop = '20px';
    button.style.cursor = 'pointer';
    button.style.width = '100%';
    button.addEventListener('click', () => {
      popup.style.display = 'none';
      document.body.style.overflow = 'auto';
    });

    popupContent.appendChild(text1);
    popupContent.appendChild(text2);
    popupContent.appendChild(button);
    popup.appendChild(popupContent);
    document.body.appendChild(popup);
  }

function startCountdown() {
  updateCountdown(); 
  timerInterval = setInterval(updateCountdown, 1000); 
}

function stopCountdown() {
  clearInterval(timerInterval);
}

  document.addEventListener("visibilitychange", function () {
  const now = new Date().getTime();

  if (document.hidden) {
    pausedTime = endTime - now;
    stopCountdown();
  } else {
    if (pausedTime > 0) {
      endTime = new Date().getTime() + pausedTime;
      pausedTime = 0; 
    }
    startCountdown();
  }
});

startCountdown();
});

